/**
 * Parse a userAgent string into a human-readable channel/browser label.
 * Used across all audit trail tabs for the "Channel" column.
 */
export const parseChannel = (ua) => {
  if (!ua) return '—';
  // API / Automation clients
  if (ua.includes('PostmanRuntime')) return 'Postman';
  if (ua.includes('curl')) return 'cURL';
  if (ua.includes('axios') || ua.includes('node-fetch') || ua.includes('Node.js')) return 'API Client';
  // Mobile apps
  if (ua.includes('WayaBank') || ua.includes('wayabank')) return 'Mobile App';
  // Mobile browsers
  if (/iPhone|iPad|iPod/.test(ua) && ua.includes('Safari') && !ua.includes('CriOS')) return 'Safari (iOS)';
  if (ua.includes('CriOS')) return 'Chrome (iOS)';
  if (ua.includes('Android') && ua.includes('Chrome')) return 'Chrome (Android)';
  if (ua.includes('Android') && ua.includes('Firefox')) return 'Firefox (Android)';
  if (ua.includes('Android')) return 'Android Browser';
  // Desktop browsers
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('OPR/') || ua.includes('Opera')) return 'Opera';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (ua.includes('Chrome/') && ua.includes('Safari/')) return 'Chrome';
  if (ua.includes('Safari/') && !ua.includes('Chrome')) return 'Safari';
  // Fallback
  return 'Other';
};

/**
 * Map channel labels to Ant Design Tag colors.
 */
export const channelTagColor = (channel) => {
  const map = {
    Chrome: 'blue',
    'Chrome (iOS)': 'blue',
    'Chrome (Android)': 'blue',
    Safari: 'green',
    'Safari (iOS)': 'green',
    Firefox: 'orange',
    'Firefox (Android)': 'orange',
    Edge: 'cyan',
    Opera: 'magenta',
    Postman: 'gold',
    cURL: 'gold',
    'API Client': 'purple',
    'Mobile App': 'volcano',
    'Android Browser': 'lime',
  };
  return map[channel] || 'default';
};
